import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import PowerMain from '../../../../components/power/PowerMain'

import { stats as ROLES_CONFIG } from '../../../../config/roles';


export default class PowerRoute extends Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (

      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.powerCharts.indexOf(this.state.role) != -1 ?
              <Paper className="col-md-11 col 11 ml-3-2vw h-100 mt-1vw p-0 customShadow" zDepth={3}>
                <PowerMain />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
} 


// WEBPACK FOOTER //
// ./routes/app/routes/power/Power.js